import {commonService} from "./common.services";
export  const userService = {
    getAllUsers,
    createUser,
    checkExistingUser,
    getUser,
    updateProfile,
    getSelectedUsers,
    checkExistingEmail,
    passwordUpdate
}

function getAllUsers(data) {

    return commonService.sendHttpRequest('rbuilder/listusers', data, "GET");
}
function createUser(data) {
    return commonService.sendHttpRequest('rbuilder/saveuser', data, "POST");
}
function passwordUpdate(data) {
    return commonService.sendHttpRequest('rbuilder/updatepassword', data, "POST");
}
function getUser(data) {
    return commonService.sendHttpRequest('rbuilder/userprofile', data, "GET");
}
function checkExistingUser(data) {
    return commonService.sendHttpRequest('rbuilder/existinguser', data, "POST");
}
function checkExistingEmail(data) {
    return commonService.sendHttpRequest('rbuilder/existingmail', data, "POST");
}
function updateProfile(data) {
    return commonService.sendHttpRequest('rbuilder/saveuserprofile', data, "POST");
}
function getSelectedUsers(data) {
    return commonService.sendHttpRequest('rbuilder/searchusers', data, "GET");
}



// WEBPACK FOOTER //
// ./src/services/user.services.js